import React, { Component } from 'react';

import Roller from './Roller/Roller'
import RollResults from './RollResults'

import {
  WarHammerChallenge, WarHammerCharacteristic,
  WarHammerConservative, WarHammerExpertise, WarHammerFortune,
  WarHammerMisfortune, WarHammerReckless,
} from './Dice/WarHammerDie';
import RandomDie from './Dice/RandomDie';

var diceTypes = [
  WarHammerChallenge, WarHammerCharacteristic,
  WarHammerConservative, WarHammerReckless,
  WarHammerExpertise,
  WarHammerFortune, WarHammerMisfortune,
  RandomDie,
];
var extraDiceTypes = [];

class WarHammerDiceApp extends Component {
  diceResults(results) {
    this.props.onUserRollAction(results)
  }

  render() {
    return (
      <div className="DiceApp">
        <div className="DiceAppSection">
          <div style={{color: 'red', marginBottom: '3px', fontSize: '12px'}}><i>VERY ROUGH DRAFT OF WARHAMMER DICE APP</i></div>
          <Roller
            onUserRollAction={this.diceResults.bind(this)}
            diceTypes={diceTypes}
            extraDiceTypes={extraDiceTypes}
            rollType='ROLL.WARHAMMER'
          />
        </div>
        <div className="DiceAppSection">
          <RollResults resultList={this.props.results} />
        </div>
      </div>
    );
  }
}

export default WarHammerDiceApp;



// WEBPACK FOOTER //
// ./src/WarHammerDiceApp.js